import BaseFormPresenter from "../../../base/BaseFormPresenter";

class InquiriesInfoPresenter extends BaseFormPresenter {
    
    async getObject() {
        const collection = this.view.getCollectionName()
        const id = this.object.id || this.view.getObjectId()
        if (id) {
            const params = { include: ['all'] }
            try {
                this.view.showProgress()
                this.object = await this.getObjectUseCase.execute(collection, id, {params})
                this.view.hideProgress()
                this.view.setObject(this.object)
                console.log(this.object.client?.email_address);
            } catch (error) {
                this.view.hideProgress()
                this.view.showError(error)
            }
        }
    }
}

export default InquiriesInfoPresenter;